export default __webpack_public_path__ + "static/media/Manrope-Light.8e695585.ttf";